var _mask, _path, _path2, _ellipse, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 187,
    viewBox: "0 0 192 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13_104",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.278 30.6303L141.552 58.3187C147.931 66.2112 152.682 75.6231 155.168 86.1604C164.023 123.706 140.764 161.321 103.219 170.176C65.6738 179.031 28.059 155.773 19.2037 118.228C10.3486 80.6828 33.6062 43.0672 71.1513 34.2119C83.5146 31.296 95.8857 31.8627 107.235 35.2745L130.112 6.11841L163.278 30.6303Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.278 30.6303L141.552 58.3187C147.931 66.2112 152.682 75.6231 155.168 86.1604C164.023 123.706 140.764 161.321 103.219 170.176C65.6738 179.031 28.059 155.773 19.2037 118.228C10.3486 80.6828 33.6062 43.0672 71.1513 34.2119C83.5146 31.296 95.8857 31.8627 107.235 35.2745L130.112 6.11841L163.278 30.6303Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.278 30.6303L167.211 33.7168L170.388 29.668L166.249 26.6093L163.278 30.6303ZM141.552 58.3187L137.619 55.2323L135.161 58.3648L137.664 61.4616L141.552 58.3187ZM155.168 86.1604L160.034 85.0127L160.034 85.0127L155.168 86.1604ZM103.219 170.176L104.367 175.042L104.367 175.042L103.219 170.176ZM19.2037 118.228L14.3373 119.376L14.3373 119.376L19.2037 118.228ZM71.1513 34.2119L70.0035 29.3454L70.0035 29.3454L71.1513 34.2119ZM107.235 35.2745L105.795 40.0628L109.062 41.045L111.168 38.361L107.235 35.2745ZM130.112 6.11841L133.084 2.09742L129.177 -0.789908L126.178 3.03192L130.112 6.11841ZM163.278 30.6303L159.344 27.5438L137.619 55.2323L141.552 58.3187L145.486 61.4052L167.211 33.7168L163.278 30.6303ZM141.552 58.3187L137.664 61.4616C143.581 68.7834 147.992 77.5165 150.301 87.3082L155.168 86.1604L160.034 85.0127C157.373 73.7297 152.281 63.6389 145.441 55.1759L141.552 58.3187ZM155.168 86.1604L150.301 87.3082C158.522 122.166 136.929 157.088 102.071 165.309L103.219 170.176L104.367 175.042C144.599 165.553 169.523 125.246 160.034 85.0127L155.168 86.1604ZM103.219 170.176L102.071 165.309C67.2137 173.53 32.2916 151.938 24.0702 117.08L19.2037 118.228L14.3373 119.376C23.8265 159.608 64.1339 184.531 104.367 175.042L103.219 170.176ZM19.2037 118.228L24.0702 117.08C15.8489 82.2226 37.4417 47.2998 72.2991 39.0784L71.1513 34.2119L70.0035 29.3454C29.7707 38.8347 4.8482 79.143 14.3373 119.376L19.2037 118.228ZM71.1513 34.2119L72.2991 39.0784C83.7853 36.3693 95.2642 36.8969 105.795 40.0628L107.235 35.2745L108.674 30.4862C96.5073 26.8285 83.2439 26.2226 70.0035 29.3454L71.1513 34.2119ZM107.235 35.2745L111.168 38.361L134.045 9.2049L130.112 6.11841L126.178 3.03192L103.301 32.188L107.235 35.2745ZM130.112 6.11841L127.14 10.1394L160.306 34.6513L163.278 30.6303L166.249 26.6093L133.084 2.09742L130.112 6.11841Z",
    fill: "black",
    mask: "url(#path-1-inside-1_13_104)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6912,
    cy: 101.741,
    rx: 60,
    ry: 57,
    fill: "black",
    fillOpacity: 0.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6912 158.162C54.5541 158.162 27.6912 131.299 27.6912 98.1617C27.6912 65.0246 51.5541 100.162 84.6912 100.162C114.246 100.162 141.81 59.5309 146.776 87.6617C147.377 91.071 147.691 94.5797 147.691 98.1617C147.691 131.299 120.828 158.162 87.6912 158.162Z",
    fill: "url(#paint0_linear_13_104)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8134 163.146C121.938 162.221 148.04 134.619 147.115 101.495C146.191 68.3706 123.318 104.16 90.1935 105.085C60.6499 105.91 31.9625 66.0642 27.7844 94.3226C27.278 97.7474 27.0622 101.263 27.1622 104.844C28.0871 137.968 55.6893 164.071 88.8134 163.146Z",
    fill: "url(#paint1_linear_13_104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_104",
    x1: 87.6912,
    y1: 77.7409,
    x2: 87.6912,
    y2: 158.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C063A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_104",
    x1: 86.5688,
    y1: 82.7565,
    x2: 88.8134,
    y2: 163.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A717D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570C71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.4aa16f089489d1222a3e729a556fe2bd.svg";
export { ForwardRef as ReactComponent };